import Styled from "styled-components";
import { respondTo } from "@/respondTo";
import { Button } from "@mui/material";

export const MainScreenContainer = Styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
background-color:var(--inverse-on-surface-light);
width:100%;
padding: 2.5rem 1.25rem;

${respondTo.desktop`
    padding:2.5rem;
`}

${respondTo.desktop_xl`
    padding:2.5rem 4.375rem;
`}
`;

export const TextContaoner = Styled.div`
  padding:0 0 1.875rem 0;

    ${respondTo.desktop_xl`
        padding:0 0 1.25rem;
    `}

    ${respondTo.desktop_xxl`
        padding:0 0 1.25rem;
    `}
  `;

export const StyledButton = Styled(Button)`
    color : var(--on-primary-container-dark);
    transition: color 0.3s ease-in-out;
    background-color:  var(--on-primary-dark);
    transition: background-color 0.3s ease-in-out;
    margin : 1.875rem 0 1.25rem;
    &:hover {
        background-color:  var(--on-primary-dark) ;
    }
    border-radius: 2rem;
    padding: 0.5rem 1.375rem;
    text-transform: none;

    ${respondTo.desktop`
        margin : 1.875rem 0 0;
    `}
`;

export const CustomLink = Styled(Button)`
    color: var(--on-primary-dark);
   text-transform: none;

    &:hover {
        cursor: pointer;
        opacity: 0.8;
    }
`;

export const HelpButtons = Styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 0 0.625rem;
    gap: 0.625rem;

    ${respondTo.desktop`
        flex-direction: row;
        align-items: baseline;
        justify-content: center;
        gap: 1.25rem;
        padding: 0 ;
        `}
    `